import { render, staticRenderFns } from "./SettingsShipBuilder.vue?vue&type=template&id=5bcd55a2&scoped=true&"
import script from "./SettingsShipBuilder.vue?vue&type=script&lang=js&"
export * from "./SettingsShipBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd55a2",
  null
  
)

export default component.exports